module.exports = __webpack_public_path__ + "img/icon-check-rounded.077e2af5.svg";